// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // // import "./PriceList.css"; // same CSS use kar sakte ho
// // import "./ProductList.css";


// // const API_URL = "https://grocerrybackend.vercel.app/api/prices";
// // const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// // function ProductList() {
// //   const [items, setItems] = useState([]);
// //   const [categories, setCategories] = useState([]);
// //   const [subcategories, setSubcategories] = useState([]);

// //   const [searchText, setSearchText] = useState("");
// //   const [filterCategory, setFilterCategory] = useState("");
// //   const [filterSubcategory, setFilterSubcategory] = useState("");

// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 20;

// //   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

// //   // ---------------------- FETCH DATA ---------------------
// //   useEffect(() => {
// //     fetchItems();
// //     fetchCategories();

// //     const handleResize = () => setIsMobile(window.innerWidth < 768);
// //     window.addEventListener("resize", handleResize);

// //     return () => window.removeEventListener("resize", handleResize);
// //   }, []);

// //   const fetchItems = async () => {
// //     try {
// //       const res = await axios.get(API_URL);
// //       if (res.data.success) setItems(res.data.data);
// //     } catch (err) {
// //       console.log("Items fetch failed", err);
// //     }
// //   };

// //   const fetchCategories = async () => {
// //     try {
// //       const res = await axios.get(CATEGORY_URL);
// //       if (res.data.success) {
// //         setCategories(res.data.categories);
// //       }
// //     } catch (err) {
// //       console.log("Category fetch failed", err);
// //     }
// //   };

// //   // ---------------------- HANDLE CATEGORY FILTER → LOAD SUBS ---------------------
// //   useEffect(() => {
// //     if (!filterCategory) {
// //       setSubcategories([]);
// //       setFilterSubcategory("");
// //       return;
// //     }

// //     const cat = categories.find((c) => c._id === filterCategory);
// //     setSubcategories(cat?.subcategories || []);
// //     setFilterSubcategory("");
// //   }, [filterCategory, categories]);

// //   // ---------------------- FILTERED LIST ---------------------
// //   const filteredItems = items.filter((item) => {
// //     const t = searchText.toLowerCase();

// //     const matchSearch =
// //       item.name.toLowerCase().includes(t) ||
// //       item.category?.name?.toLowerCase().includes(t) ||
// //       item.subcategory?.name?.toLowerCase().includes(t);

// //     const matchCategory =
// //       !filterCategory || item.category?._id === filterCategory;

// //     const matchSubcategory =
// //       !filterSubcategory || item.subcategory?._id === filterSubcategory;

// //     return matchSearch && matchCategory && matchSubcategory;
// //   });

// //   // ---------------------- PAGINATION ---------------------
// //   const indexOfLast = currentPage * itemsPerPage;
// //   const renderedItems = filteredItems.slice(indexOfLast - itemsPerPage, indexOfLast);
// //   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

// //   return (
// //     <div className="price-container">

// //       {/* ---------------- HEADER ---------------- */}
// //       <div className="header-section">
// //         <h1>📦 Product List</h1>
// //         <p>View all products with sorting, search & category filters.</p>
// //       </div>

// //       {/* ---------------- FILTER BAR ---------------- */}
// //       <div className="filter-bar">

// //         {/* SEARCH */}
// //         <input
// //           type="text"
// //           placeholder="Search product, category or subcategory..."
// //           value={searchText}
// //           onChange={(e) => {
// //             setCurrentPage(1);
// //             setSearchText(e.target.value);
// //           }}
// //         />

// //         {/* CATEGORY FILTER */}
// //         <select
// //           value={filterCategory}
// //           onChange={(e) => { 
// //             setFilterCategory(e.target.value);
// //             setCurrentPage(1);
// //           }}
// //         >
// //           <option value="">All Categories</option>
// //           {categories.map((c) => (
// //             <option key={c._id} value={c._id}>
// //               {c.name}
// //             </option>
// //           ))}
// //         </select>

// //         {/* SUBCATEGORY FILTER */}
// //         <select
// //           value={filterSubcategory}
// //           disabled={!subcategories.length}
// //           onChange={(e) => {
// //             setFilterSubcategory(e.target.value);
// //             setCurrentPage(1);
// //           }}
// //         >
// //           <option value="">All Subcategories</option>
// //           {subcategories.map((s) => (
// //             <option key={s._id} value={s._id}>
// //               {s.name}
// //             </option>
// //           ))}
// //         </select>

// //       </div>

// //       {/* ---------------- LIST TABLE ---------------- */}
// //       <div className="table-card">
// //         <div className="table-header">
// //           <h2>📋 Items</h2>
// //           <span>Total: {filteredItems.length}</span>
// //         </div>

// //         {/* DESKTOP TABLE */}
// //         {!isMobile ? (
// //           <table>
// //             <thead>
// //               <tr>
// //                 <th>Sr</th>
// //                 <th>Image</th>
// //                 <th>Name</th>
// //                 {/* <th>Category</th>
// //                 <th>Subcategory</th> */}
// //                 <th>Base</th>
// //                 <th>Diff</th>
// //                 <th>Final</th>
// //                 {/* <th>Valid Till</th> */}
                
// //               </tr>
// //             </thead>

// //             <tbody>
// //               {renderedItems.map((item, i) => (
// //                 <tr key={item._id}>
// //                   <td>{(currentPage - 1) * itemsPerPage + (i + 1)}</td>

// //                   <td>
// //                     {item.image ? (
// //                       <img src={item.image} alt="img" />
// //                     ) : (
// //                       "No Img"
// //                     )}
// //                   </td>

// //                   <td>{item.name}</td>
// // {/* 
// //                   <td>{item.category?.name}</td>

// //                   <td>{item.subcategory?.name || "-"}</td> */}

// //                   <td>₹{item.basePrice}</td>

// //                   <td>{item.difference || 0}</td>

// //                   <td>₹{Number(item.basePrice) + Number(item.difference || 0)}</td>

// //                   {/* <td>
// //                     {item.validTill
// //                       ? new Date(item.validTill).toLocaleDateString()
// //                       : "-"}
// //                   </td> */}

// //                   {/* <td>
// //                     {item.status === "active" ? (
// //                       <span className="status-active">🟢 Active</span>
// //                     ) : (
// //                       <span className="status-inactive">🔴 Inactive</span>
// //                     )}
// //                   </td> */}
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         ) : (
// //           /* ---------------- MOBILE CARD VIEW ---------------- */
// //           <div className="mobile-list">
// //             {renderedItems.map((item) => (
// //               <div key={item._id} className="mobile-card">
// //                 {item.image ? (
// //                   <img src={item.image} alt="img" />
// //                 ) : (
// //                   <div>No Image</div>
// //                 )}

// //                 <h3>{item.name}</h3>

// //                 {/* <p><b>Category:</b> {item.category?.name}</p>
// //                 <p><b>Subcategory:</b> {item.subcategory?.name || "-"}</p> */}
// //                 <p><b>Base:</b> ₹{item.basePrice}</p>
// //                 <p><b>Difference:</b> ₹{item.difference || 0}</p>
// //                 <p><b>Final:</b> ₹{Number(item.basePrice) + Number(item.difference || 0)}</p>

// //                 {/* <p className={item.status === "active" ? "status-active" : "status-inactive"}>
// //                   {item.status === "active" ? "🟢 Active" : "🔴 Inactive"}
// //                 </p> */}
// //               </div>
// //             ))}
// //           </div>
// //         )}

// //         {/* ---------------- PAGINATION ---------------- */}
// //         <div className="pagination">
// //           <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
// //             Previous
// //           </button>

// //           {Array.from({ length: totalPages }).map((_, i) => (
// //             <button
// //               key={i}
// //               className={currentPage === i + 1 ? "active-page" : ""}
// //               onClick={() => setCurrentPage(i + 1)}
// //             >
// //               {i + 1}
// //             </button>
// //           ))}

// //           <button
// //             disabled={currentPage === totalPages}
// //             onClick={() => setCurrentPage((p) => p + 1)}
// //           >
// //             Next
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default ProductList;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./ProductList.css";

// const API_URL = "https://grocerrybackend.vercel.app/api/prices";
// const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// function ProductList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   const [searchText, setSearchText] = useState("");
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 20;

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     fetchItems();
//     fetchCategories();

//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const fetchItems = async () => {
//     try {
//       const res = await axios.get(API_URL);
//       if (res.data.success) setItems(res.data.data);
//     } catch (err) {
//       console.log("Items fetch failed", err);
//     }
//   };

//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data.success) {
//         setCategories(res.data.categories);
//       }
//     } catch (err) {
//       console.log("Category fetch failed", err);
//     }
//   };

//   useEffect(() => {
//     if (!filterCategory) {
//       setSubcategories([]);
//       setFilterSubcategory("");
//       return;
//     }

//     const cat = categories.find((c) => c._id === filterCategory);
//     setSubcategories(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   const filteredItems = items.filter((item) => {
//     const t = searchText.toLowerCase();

//     const matchSearch =
//       item.name.toLowerCase().includes(t) ||
//       item.category?.name?.toLowerCase().includes(t) ||
//       item.subcategory?.name?.toLowerCase().includes(t);

//     const matchCategory =
//       !filterCategory || item.category?._id === filterCategory;

//     const matchSubcategory =
//       !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchSearch && matchCategory && matchSubcategory;
//   });

//   const indexOfLast = currentPage * itemsPerPage;
//   const renderedItems = filteredItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

//   return (
//     <div className="price-container">
//       <div className="header-section">
//         <h1> Product List</h1>
        
//       </div>

//       <div className="filter-bar">
//         <input
//           type="text"
//           placeholder="Search product, category or subcategory..."
//           value={searchText}
//           onChange={(e) => {
//             setCurrentPage(1);
//             setSearchText(e.target.value);
//           }}
//         />

//         <select
//           value={filterCategory}
//           onChange={(e) => {
//             setFilterCategory(e.target.value);
//             setCurrentPage(1);
//           }}
//         >
//           <option value="">All Categories</option>
//           {categories.map((c) => (
//             <option key={c._id} value={c._id}>
//               {c.name}
//             </option>
//           ))}
//         </select>

//         <select
//           value={filterSubcategory}
//           disabled={!subcategories.length}
//           onChange={(e) => {
//             setFilterSubcategory(e.target.value);
//             setCurrentPage(1);
//           }}
//         >
//           <option value="">All Subcategories</option>
//           {subcategories.map((s) => (
//             <option key={s._id} value={s._id}>
//               {s.name}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="table-card">
//         <div className="table-header">
//           <h2> Items</h2>
//           <span>Total: {filteredItems.length}</span>
//         </div>

//         {/* Always show table on mobile & desktop */}
//         <div className="table-scroll">
//           <table>
//             <thead>
//               <tr>
//                 <th>Sr</th>
//                 <th>Image</th>
//                 <th>Name</th>
//                 <th>Base</th>
//                 <th>Diff</th>
//                 <th>Final</th>
//               </tr>
//             </thead>

//             <tbody>
//               {renderedItems.map((item, i) => (
//                 <tr key={item._id}>
//                   <td>{(currentPage - 1) * itemsPerPage + (i + 1)}</td>

//                   <td>
//                     {item.image ? (
//                       <img src={item.image} alt="img" />
//                     ) : (
//                       "No Img"
//                     )}
//                   </td>

//                   <td>{item.name}</td>

//                   <td>₹{item.basePrice}</td>

//                   <td>{item.difference || 0}</td>

//                   <td>₹{Number(item.basePrice) + Number(item.difference || 0)}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className="pagination">
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
//             Previous
//           </button>

//           {Array.from({ length: totalPages }).map((_, i) => (
//             <button
//               key={i}
//               className={currentPage === i + 1 ? "active-page" : ""}
//               onClick={() => setCurrentPage(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProductList;




















// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./ProductList.css";

// const API_URL = "https://grocerrybackend.vercel.app/api/prices";
// const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// function ProductList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);

//   const [searchText, setSearchText] = useState("");
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 20;

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     fetchItems();
//     fetchCategories();

//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // --------------------- FETCH ITEMS ---------------------
//   const fetchItems = async () => {
//     try {
//       const res = await axios.get(API_URL);

//       if (res.data.success) {
//         const data = res.data.data.map((item) => ({
//           ...item,

//           // ⭐ Normalized fields
//           todayDiff: item.todayDiff ?? item.difference ?? 0,

//           lastFinalPrice:
//             item.lastFinalPrice && item.lastFinalPrice > 0
//               ? item.lastFinalPrice
//               : item.basePrice,

//           currentFinalPrice:
//             item.currentFinalPrice && item.currentFinalPrice > 0
//               ? item.currentFinalPrice
//               : (item.basePrice + (item.todayDiff ?? 0)),
//         }));

//         setItems(data);
//       }
//     } catch (err) {
//       console.log("Items fetch failed", err);
//     }
//   };

//   // ---------------- FETCH CATEGORIES ----------------
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data.success) {
//         setCategories(res.data.categories);
//       }
//     } catch (err) {
//       console.log("Category fetch failed", err);
//     }
//   };

//   // ---------------- FILTER SUBCATEGORIES ----------------
//   useEffect(() => {
//     if (!filterCategory) {
//       setSubcategories([]);
//       setFilterSubcategory("");
//       return;
//     }

//     const cat = categories.find((c) => c._id === filterCategory);
//     setSubcategories(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   // ---------------- FILTERING ----------------
//   const filteredItems = items.filter((item) => {
//     const t = searchText.toLowerCase();

//     const matchSearch =
//       item.name?.toLowerCase().includes(t) ||
//       item.category?.name?.toLowerCase().includes(t) ||
//       item.subcategory?.name?.toLowerCase().includes(t);

//     const matchCategory =
//       !filterCategory || item.category?._id === filterCategory;

//     const matchSubcategory =
//       !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchSearch && matchCategory && matchSubcategory;
//   });

//   // ---------------- PAGINATION ----------------
//   const indexOfLast = currentPage * itemsPerPage;
//   const renderedItems = filteredItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

//   return (
//     <div className="price-container">
//       <div className="header-section">
//         <h1>Product List</h1>
//       </div>

//       {/* ---------------- FILTER BAR ---------------- */}
//       <div className="filter-bar">
//         <input
//           type="text"
//           placeholder="Search product, category or subcategory..."
//           value={searchText}
//           onChange={(e) => {
//             setCurrentPage(1);
//             setSearchText(e.target.value);
//           }}
//         />

//         <select
//           value={filterCategory}
//           onChange={(e) => {
//             setFilterCategory(e.target.value);
//             setCurrentPage(1);
//           }}
//         >
//           <option value="">All Categories</option>
//           {categories.map((c) => (
//             <option key={c._id} value={c._id}>
//               {c.name}
//             </option>
//           ))}
//         </select>

//         {/* <select
//           value={filterSubcategory}
//           disabled={!subcategories.length}
//           onChange={(e) => {
//             setFilterSubcategory(e.target.value);
//             setCurrentPage(1);
//           }}
//         >
//           <option value="">All Subcategories</option>
//           {subcategories.map((s) => (
//             <option key={s._id} value={s._id}>
//               {s.name}
//             </option>
//           ))}
//         </select> */}
//       </div>

//       {/* ---------------- TABLE ---------------- */}
//       <div className="table-card">
//         <div className="table-header">
//           <h2>Items</h2>
//           <span>Total: {filteredItems.length}</span>
//         </div>

//         <div className="table-scroll">
//           <table>
//             <thead>
//               <tr>
//                 <th>Sr</th>
//                 <th>Image</th>
//                 <th>Name</th>
//                 <th>Base</th>
//                 <th>Yesterday Final</th>
//                 <th>Today Diff</th>
//                 <th>Final</th>
//               </tr>
//             </thead>

//             <tbody>
//               {renderedItems.map((item, i) => (
//                 <tr key={item._id}>
//                   <td>{(currentPage - 1) * itemsPerPage + (i + 1)}</td>

//                   <td>
//                     {item.image ? (
//                       <img src={item.image} alt="img" />
//                     ) : (
//                       "No Img"
//                     )}
//                   </td>

//                   <td>{item.name}</td>

//                   <td>₹{item.basePrice}</td>

//                   <td>₹{item.lastFinalPrice}</td>

//                   <td>{item.todayDiff}</td>

//                   <td style={{ fontWeight: "700" }}>
//                     ₹{item.currentFinalPrice}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* ---------------- PAGINATION ---------------- */}
//         <div className="pagination">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((p) => p - 1)}
//           >
//             Previous
//           </button>

//           {Array.from({ length: totalPages }).map((_, i) => (
//             <button
//               key={i}
//               className={currentPage === i + 1 ? "active-page" : ""}
//               onClick={() => setCurrentPage(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ProductList;




























import React, { useEffect, useState } from "react";
import axios from "axios";

// --- API Endpoints ---
const API_URL = "https://grocerrybackend.vercel.app/api/prices";
const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// ⭐ Helper component to display price difference with color and arrow
const PriceDiff = ({ diff, isMobile = false }) => {
  const diffNum = Number(diff) || 0;
  const isPositive = diffNum > 0;
  const isNegative = diffNum < 0;

  // Red for price increase, Green for price decrease
  const diffClasses = isPositive
    ? "text-red-600 font-bold bg-red-100/70"
    : isNegative
    ? "text-green-600 font-bold bg-green-100/70"
    : "text-gray-500 font-medium bg-gray-100";
    
  // Use a slightly larger size if in the main desktop column, smaller if nested
  const sizeClasses = isMobile ? "px-1 py-0.5" : "px-2 py-0.5";

  const symbol = isPositive ? "↑" : isNegative ? "↓" : "—";
  const value = Math.abs(diffNum).toFixed(2);

  return (
    <span className={`flex items-center justify-center gap-1 text-xs rounded shadow-sm ${diffClasses} ${sizeClasses}`}>
      {symbol} {value}
    </span>
  );
};

function ProductList() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [filterSubcategory, setFilterSubcategory] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [loading, setLoading] = useState(true);

  // --------------------- INITIAL FETCH ---------------------
  useEffect(() => {
    fetchItems();
    fetchCategories();
  }, []);

  // --------------------- FETCH ITEMS & PRICE NORMALIZATION ---------------------
  const fetchItems = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_URL);

      if (res.data.success) {
        const data = (res.data.data || []).map((item) => {
          // Data normalization and price calculation
          const todayDiff = Number(item.todayDiff ?? item.difference ?? 0);
          const basePrice = Number(item.basePrice || 0);
          const lastFinalPrice = Number(item.lastFinalPrice || basePrice); 
          const currentFinalPrice = (lastFinalPrice + todayDiff); 

          return {
            ...item,
            todayDiff: todayDiff.toFixed(2),
            lastFinalPrice: lastFinalPrice.toFixed(2),
            currentFinalPrice: currentFinalPrice.toFixed(2),
            basePrice: basePrice.toFixed(2),
          };
        });

        setItems(data);
      }
    } catch (err) {
      console.error("Items fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  // ---------------- FETCH CATEGORIES ----------------
  const fetchCategories = async () => {
    try {
      const res = await axios.get(CATEGORY_URL);
      if (res.data.success) {
        setCategories(res.data.categories || []);
      }
    } catch (err) {
      console.error("Category fetch failed", err);
    }
  };

  // ---------------- FILTER LOGIC ----------------
  useEffect(() => {
    setFilterSubcategory("");
    setCurrentPage(1);
    if (!filterCategory) {
      setSubcategories([]);
      return;
    }
    const cat = categories.find((c) => c._id === filterCategory);
    setSubcategories(cat?.subcategories || []);
  }, [filterCategory, categories]);

  const filteredItems = items.filter((item) => {
    const t = searchText.toLowerCase();
    const matchSearch =
      item.name?.toLowerCase().includes(t) ||
      item.category?.name?.toLowerCase().includes(t) ||
      item.subcategory?.name?.toLowerCase().includes(t);
    const matchCategory =
      !filterCategory || item.category?._id === filterCategory;
    const matchSubcategory =
      !filterSubcategory || item.subcategory?._id === filterSubcategory;
    return matchSearch && matchCategory && matchSubcategory;
  });

  // ---------------- PAGINATION LOGIC ----------------
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const renderedItems = filteredItems.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [filteredItems.length, totalPages]);

  // PriceDiff Component
  const PriceDiff = ({ diff, isMobile = false }) => {
    const diffNum = parseFloat(diff);
    const isPositive = diffNum > 0;
    const isNegative = diffNum < 0;
    const fontSize = isMobile ? "text-xs" : "text-sm";
    
    return (
      <span className={`inline-flex items-center px-2 py-1 rounded-full font-medium ${fontSize} ${
        isPositive 
          ? "bg-green-100 text-green-800" 
          : isNegative 
          ? "bg-red-100 text-red-800" 
          : "bg-gray-100 text-gray-800"
      }`}>
        {isPositive ? "↗" : isNegative ? "↘" : "→"}
        <span className="ml-1">
          {isPositive ? "+" : ""}{diff}
        </span>
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 p-2 md:p-4">
      {/* HEADER */}
      <div className="mb-3 md:mb-5">
        <div className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6 text-indigo-600" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 2a8 8 0 100 16 8 8 0 000-16zM4.332 7.773a.5.5 0 01.35.86l.665.664A3 3 0 0010 13a3 3 0 004.654-3.528l.665-.664a.5.5 0 01.35-.861A7.994 7.994 0 0010 4a7.994 7.994 0 00-5.668 3.773z" clipRule="evenodd" />
          </svg>
          <h1 className="text-lg md:text-2xl font-bold text-gray-800">Price Tracker</h1>
        </div>
        <p className="text-xs md:text-sm text-gray-600 mt-1">Tracking {filteredItems.length} products</p>
      </div>

      {/* FILTERS SECTION */}
      <div className="bg-white rounded-lg border border-gray-200 p-3 md:p-4 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          {/* Search */}
          <div className="relative md:col-span-2">
            <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search product or category..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={searchText}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchText(e.target.value);
              }}
            />
          </div>

          {/* Category Filter */}
          <select
            className="py-2 px-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white"
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map((c) => (
              <option key={c._id} value={c._id}>{c.name}</option>
            ))}
          </select>

          {/* Subcategory Filter */}
          <select
            className="py-2 px-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none disabled:opacity-50 disabled:bg-gray-100"
            value={filterSubcategory}
            disabled={!filterCategory || !subcategories.length}
            onChange={(e) => {
              setFilterSubcategory(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Subcategories</option>
            {subcategories.map((s) => (
              <option key={s._id} value={s._id}>{s.name}</option>
            ))}
          </select>
        </div>
      </div>

      {/* MOBILE VIEW - CARD LAYOUT */}
      <div className="md:hidden space-y-3">
        {loading ? (
          <div className="bg-white rounded-lg border border-gray-200 p-6 text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mb-3"></div>
            <p className="text-sm text-gray-600">Loading products...</p>
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="bg-white rounded-lg border border-gray-200 p-6 text-center">
            <div className="text-2xl mb-2">😢</div>
            <p className="text-sm text-gray-600">No products found matching filters</p>
          </div>
        ) : (
          renderedItems.map((item) => (
            <div key={item._id} className="bg-white rounded-lg border border-gray-200 p-3">
              {/* Card Header */}
              <div className="flex items-start gap-3">
                {/* Image */}
                <div className="flex-shrink-0">
                  {item.image ? (
                    <img src={item.image} alt={item.name} className="w-12 h-12 rounded-lg object-cover border" />
                  ) : (
                    <div className="w-12 h-12 flex items-center justify-center bg-gray-100 text-gray-400 rounded-lg border">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 text-sm truncate">{item.name}</h3>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {item.subcategory?.name || item.category?.name || "Uncategorized"}
                  </p>
                  
                  {/* Price and Change Row */}
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center gap-2">
                      <PriceDiff diff={item.todayDiff} isMobile={true} />
                      <span className="text-lg font-bold text-indigo-700">₹{item.currentFinalPrice}</span>
                    </div>
                    <div className="text-right">
                      <div className="text-xs text-gray-500">Prev: ₹{item.lastFinalPrice}</div>
                      <div className="text-xs text-gray-500">Base: ₹{item.basePrice}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* DESKTOP VIEW - TABLE LAYOUT */}
      <div className="hidden md:block bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-sm font-semibold text-gray-800">Product Price History</h2>
          <span className="px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800 rounded">
            {filteredItems.length} products
          </span>
        </div>

        {loading ? (
          <div className="p-8 text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mb-3"></div>
            <p className="text-gray-600">Loading product data...</p>
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="p-8 text-center">
            <div className="text-3xl mb-3">😢</div>
            <p className="text-gray-600">No products found matching the selected filters</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Product</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Today Diff</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Final</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Yesterday Final </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Base</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {renderedItems.map((item) => (
                  <tr key={item._id} className="hover:bg-gray-50">
                    {/* Product Column */}
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        {item.image ? (
                          <img src={item.image} alt={item.name} className="w-10 h-10 rounded object-cover border" />
                        ) : (
                          <div className="w-10 h-10 flex items-center justify-center bg-gray-100 text-gray-400 rounded border">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                          </div>
                        )}
                        <div>
                          <div className="font-medium text-sm text-gray-900 truncate max-w-[200px]">{item.name}</div>
                          <div className="text-xs text-gray-500">{item.subcategory?.name || "—"}</div>
                        </div>
                      </div>
                    </td>

                    {/* Change Column */}
                    <td className="px-4 py-3 text-center">
                      <PriceDiff diff={item.todayDiff} />
                    </td>

                    {/* Current Price */}
                    <td className="px-4 py-3 text-right font-bold text-indigo-700 text-sm">
                      ₹{item.currentFinalPrice}
                    </td>

                    {/* Previous Price */}
                    <td className="px-4 py-3 text-right text-gray-600 text-sm">
                      ₹{item.lastFinalPrice}
                    </td>

                    {/* Category */}
                    <td className="px-4 py-3 text-sm text-gray-600">
                      {item.category?.name || "—"}
                    </td>

                    {/* Base Price */}
                    <td className="px-4 py-3 text-right text-gray-500 text-sm">
                      ₹{item.basePrice}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="px-4 py-3 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="text-xs text-gray-600">
              Page {currentPage} of {totalPages}
            </div>
            
            <div className="flex items-center gap-2">
              <button
                className="px-3 py-1.5 border border-gray-300 rounded text-xs font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(p => p - 1)}
              >
                Previous
              </button>
              
              <div className="flex items-center gap-1">
                {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                  const pageNum = i + 1;
                  if (totalPages > 5 && currentPage > 3) {
                    // Show dynamic pagination for many pages
                    const start = Math.max(1, currentPage - 2);
                    const end = Math.min(totalPages, currentPage + 2);
                    
                    if (i === 0) return (
                      <button key={1} onClick={() => setCurrentPage(1)} className="px-2 py-1 text-xs">1</button>
                    );
                    if (i === 4) return (
                      <button key={totalPages} onClick={() => setCurrentPage(totalPages)} className="px-2 py-1 text-xs">{totalPages}</button>
                    );
                    return (
                      <button
                        key={start + i - 1}
                        onClick={() => setCurrentPage(start + i - 1)}
                        className={`px-2 py-1 text-xs rounded ${currentPage === start + i - 1 ? 'bg-indigo-600 text-white' : 'hover:bg-gray-100'}`}
                      >
                        {start + i - 1}
                      </button>
                    );
                  }
                  
                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`px-2 py-1 text-xs rounded ${currentPage === pageNum ? 'bg-indigo-600 text-white' : 'hover:bg-gray-100'}`}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              
              <button
                className="px-3 py-1.5 border border-gray-300 rounded text-xs font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(p => p + 1)}
              >
                Next
              </button>
            </div>
            
            <div className="text-xs text-gray-500">
              {filteredItems.length} total products
            </div>
          </div>
        )}
      </div>

      {/* MOBILE PAGINATION */}
      {totalPages > 1 && (
        <div className="md:hidden bg-white rounded-lg border border-gray-200 p-3 mt-3">
          <div className="flex items-center justify-between mb-2">
            <button
              className="px-3 py-1.5 border border-gray-300 rounded text-xs font-medium disabled:opacity-50"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(p => p - 1)}
            >
              ← Prev
            </button>
            
            <div className="text-xs text-gray-600">
              Page {currentPage} of {totalPages}
            </div>
            
            <button
              className="px-3 py-1.5 border border-gray-300 rounded text-xs font-medium disabled:opacity-50"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(p => p + 1)}
            >
              Next →
            </button>
          </div>
          
          <div className="flex flex-wrap gap-1 justify-center">
            {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
              const pageNum = i + 1;
              return (
                <button
                  key={pageNum}
                  onClick={() => setCurrentPage(pageNum)}
                  className={`px-2 py-1 text-xs rounded ${currentPage === pageNum ? 'bg-indigo-600 text-white' : 'bg-gray-100'}`}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductList;